<template src="./html/FilterBar.html"></template>

<script>
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth', 'sales', 'purchases'],
		data () {
			return {
				projects: null,
				users: null,

				filter: {
					allowDate: false,
					date: null,
					text: null,
					sales: this.sales,
					purchases: this.purchases,
				}
			}
		},
		watch: {
			'filter.allowDate'() {
				this.initDate()
			}
		},
		methods: {
			collapse() {
				$(this.$refs.filter).collapse("toggle")
			},
			keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 13) {
						this.doFilter()
					} else {
						if(event.code != 32) {
							this.doFilter()
						}
					}
				} else {
					this.doFilter()
				}
			},
			doFilter() {
				if(this.filter.text) {
					this.filter.text = this.filter.text.trimStart()
				}
				if(!this.filter.allowDate) {
					this.filter.date = null
				}
				this.$events.fire('filterSet', this.filter)
			},
			clearData() {
				this.filter.text = null
				this.filter.allowDate = false
				this.filter.date = null
			},
			reset() {
				this.clearData()
				this.$events.fire('filterReset', this.filter)
			},
			initDate() {
				var that = this
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('.daterange').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				}).on('hide.daterangepicker', function(e, picker) {
					that.filter.date = moment(picker.startDate).format('DD/MM/YY') + ' - ' +moment(picker.endDate).format('DD/MM/YY')
				})
				this.filter.date = startDate.format('DD/MM/YY') + ' - ' + endDate.format('DD/MM/YY')
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/FilterBar.vue